import { getLocalStorageData } from '../../../utils/helper';
import { APP_API_URL_V2 } from '../../../utils/xhr-instance';
import { axiosInstanceV2 } from '../../axios';

export async function updateProfileSettings(data) {
	const API_URL = `${APP_API_URL_V2}/settings/organisation`;
	const token = getLocalStorageData();
	return await axiosInstanceV2
		.put(API_URL, data, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		})
		.then((res) => res.data)
		.catch((err) => err?.response?.data || 'Something went wrong');
}

export async function updateOrganizationLogo(data) {
	const API_URL = `${APP_API_URL_V2}/settings/organisation/logo`;
	const token = getLocalStorageData();
	return await axiosInstanceV2
		.post(API_URL, data, {
			headers: {
				'Content-Type': 'multipart/form-data',
				Authorization: `Bearer ${token?.token}`,
			},
		})
		.then((res) => res.data.data)
		.catch((err) => err?.response?.data || 'Something went wrong');
}

export async function updatePrimaryContact(data) {
	const API_URL = `${APP_API_URL_V2}/settings/organisation/primary-contact`;
	const token = getLocalStorageData();
	return await axiosInstanceV2
		.put(API_URL, data, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		})
		.then((res) => res.data)
		.catch((err) => err?.response?.data || 'Something went wrong');
}

export async function getOrganizationProfile() {
	const API_URL = `${APP_API_URL_V2}/settings/organisation`;
	const token = getLocalStorageData();
	return await axiosInstanceV2
		.get(API_URL, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		})
		.then((res) => {
			return res.data.data;
		})
		.catch((error) => {
			return error.response?.data;
		});
}
export async function verifyOrgDomain(domain) {
	const API_URL = `${APP_API_URL_V2}/settings/organisation/verify-domain/${domain}`;
	const token = getLocalStorageData();
	return await axiosInstanceV2
		.get(API_URL, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		})
		.then((res) => {
			return res.data.data;
		})
		.catch((error) => {
			return error.response?.data;
		});
}
export async function getBranding() {
	const API_URL = `${APP_API_URL_V2}/settings/organisation/branding`;
	const token = getLocalStorageData();
	return await axiosInstanceV2
		.get(API_URL, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		})
		.then((res) => {
			return res.data.data;
		})
		.catch((error) => {
			return error.response?.data;
		});
}
export async function updateBranding(data) {
	const API_URL = `${APP_API_URL_V2}/settings/organisation/branding`;
	const token = getLocalStorageData();
	return await axiosInstanceV2
		.put(API_URL, data, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		})
		.then((res) => res.data)
		.catch((err) => err?.response?.data || 'Something went wrong');
}

export async function getCurrencyList(params) {
	const API_URL = `${APP_API_URL_V2}/settings/organisation/currencies`;
	const token = getLocalStorageData();
	return await axiosInstanceV2
		.get(API_URL, {
			params,
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		})
		.then((res) => res.data.data)
		.catch((error) => error?.response?.data);
}

export async function createCurrencies(data) {
	const API_URL = `${APP_API_URL_V2}/settings/organisation/currencies`;
	const token = getLocalStorageData();
	return await axiosInstanceV2
		.post(API_URL, data, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		})
		.then((res) => res.data)
		.catch((err) => err?.response?.data || 'Something went wrong');
}

export async function deleteCurrency(id) {
	const API_URL = `${APP_API_URL_V2}/settings/organisation/currencies/delete/${id}`;
	const token = getLocalStorageData();
	return await axiosInstanceV2
		.delete(API_URL, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		})
		.then((res) => res.data)
		.catch((error) => error?.response?.data);
}

export async function getGSTSetting() {
	const API_URL = `${APP_API_URL_V2}/settings/organisation/gst-settings`;
	const token = getLocalStorageData();
	return await axiosInstanceV2
		.get(API_URL, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		})
		.then((res) => res.data.data)
		.catch((error) => error?.response?.data);
}

export async function updateGstSetting(data) {
	const API_URL = `${APP_API_URL_V2}/settings/organisation/gst-settings`;
	const token = getLocalStorageData();
	return await axiosInstanceV2
		.put(API_URL, data, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		})
		.then((res) => res.data)
		.catch((err) => err?.response?.data || 'Something went wrong');
}

export async function getTaxRates(params) {
	const API_URL = `${APP_API_URL_V2}/settings/organisation/tax-rates`;
	const token = getLocalStorageData();
	return await axiosInstanceV2
		.get(API_URL, {
			params,
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		})
		.then((res) => res.data.data)
		.catch((error) => error?.response?.data);
}

export async function createTaxRates(data) {
	const API_URL = `${APP_API_URL_V2}/settings/organisation/tax-rates`;
	const token = getLocalStorageData();
	return await axiosInstanceV2
		.post(API_URL, data, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		})
		.then((res) => res.data)
		.catch((err) => err?.response?.data || 'Something went wrong');
}
export async function updateStatusTaxRates(data) {
	const API_URL = `${APP_API_URL_V2}/settings/organisation//tax-rates/update-status`;
	const token = getLocalStorageData();
	return await axiosInstanceV2
		.post(API_URL, data, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		})
		.then((res) => res.data)
		.catch((err) => err?.response?.data || 'Something went wrong');
}

export async function deleteTaxRate(id) {
	const API_URL = `${APP_API_URL_V2}/settings/organisation/tax-rates/delete/${id}`;
	const token = getLocalStorageData();
	return await axiosInstanceV2
		.delete(API_URL, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		})
		.then((res) => res.data)
		.catch((error) => error?.response?.data);
}
